import { weenatIntl as wintl } from '@weenat/wintl';
import moment from 'moment-timezone';
import { commons, isMetricCompatibleWithExport, measurements } from '../../enums/MetricIds';
import TimeSteps from '../../enums/TimeSteps';
const allMetrics = [...commons, ...measurements, 'etp'];
export const getExportMetricsOptions = () => allMetrics.reduce((acc, metric) => {
    if (isMetricCompatibleWithExport(metric)) {
        const key = `metrics.${metric}`;
        acc.push({
            value: metric,
            label: wintl.t(key, { capitalize: true })
        });
    }
    return acc;
}, []);
export const exportFormats = ['xlsx', 'csv'];
export const getFormatOptions = () => exportFormats.map((f) => ({ value: f, label: f }));
export const exportTimeSteps = [
    TimeSteps.perHours,
    TimeSteps.perDays,
    TimeSteps.perWeek,
    TimeSteps.perMonth,
    TimeSteps.perYears
];
export const getExportTimeStepsOptions = () => exportTimeSteps.map((ts) => ({
    value: ts,
    label: wintl.t(`timeSteps.${ts}`, { capitalize: true })
}));
export const getAllowedExportPeriod = () => {
    return { start: moment().subtract(1, 'year').toDate(), end: moment().toDate() };
};
